import { Localized } from "@fluent/react"
import { styled } from '@mui/material/styles'
import { ChangeEvent, useCallback } from "react"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { Locale, selectSettingByCode, selectSettings, sessionDurationCode, setLocalePersistent } from "./settingsSlice"
import MenuItem from '@mui/material/MenuItem'
import TextField from "@mui/material/TextField"
import Container from '@mui/material/Container'
import { Box } from "@mui/material"

const PREFIX = 'Settings';

const classes = {
    dropdown: `${PREFIX}-dropdown`
};

const StyledContainer = styled(Container)(( { theme }) => ({
    [`& .${classes.dropdown}`]: {
        width: "100%",
    }
}));

const langs: Record<Locale, string> = {
    "en-US": "English",
    "pl": "Polski",
    "de": "Deutsch"
}

const opts = Object.entries<string>(langs).map(lang => {
    const [value, label] = lang;
    return { 
        value,
        label,
    };
})

export const Settings = () => {
    const dispatch = useAppDispatch();
    const { locale } = useAppSelector(selectSettings);

    const activityTimeout = useAppSelector(state => selectSettingByCode(state.settings.companySettings, sessionDurationCode)?.value ?? "5")

    const handleLangChange = useCallback((e: ChangeEvent<{value: unknown}>) => {
        dispatch(setLocalePersistent(e.target.value as Locale));
    }, [dispatch])

    return (
        <StyledContainer maxWidth="sm">
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            }}>
                <TextField 
                    select 
                    label={<Localized id="settings-lang">Język</Localized>} 
                    className={classes.dropdown}
                    value={locale}
                    onChange={handleLangChange}
                >
                    {opts.map(lang => {
                        const { value, label } = lang;
                        return <MenuItem key={value} value={value}>{label}</MenuItem>;
                    })}
                </TextField>
                <TextField 
                    disabled
                    label={<Localized id="settings-activity-timeout">Długość sesji</Localized>} 
                    className={classes.dropdown}
                    value={`${activityTimeout} min` }
                />
            </Box>
        </StyledContainer>
    );
}
